<p>studiewijzerlinkjes-vaksectie-platform-details works!</p>
<app-studiewijzerlinkjes-vaksectie-platform-details-table-row-component></app-studiewijzerlinkjes-vaksectie-platform-details-table-row-component>
